import React, { createContext, PropsWithChildren, useContext, useEffect, useMemo, useRef, useState } from "react";

type LastTabContextType = {lastOpenedTab: null | string, setLastOpenedTab: (tab: string | null) => void };

const LastTabContext = createContext<LastTabContextType>({ lastOpenedTab: null, setLastOpenedTab: () => {} });

export const LastTabContextProvider = (props: PropsWithChildren<{ resetKey?: string; initialTab: string | undefined }>) => {
    const initialTab = useRef(props.initialTab).current;

    const [lastOpenedTab, setLastOpenedTab ] = useState(initialTab ?? null);

    const contextValue = useMemo(() => ({ lastOpenedTab, setLastOpenedTab }), [lastOpenedTab, setLastOpenedTab]);

    useEffect(() => {
        setLastOpenedTab(null);
    }, [props.resetKey]);


    return <LastTabContext.Provider value={contextValue} children={props.children} />;
}

export const useLastTabContext = () => useContext(LastTabContext)